export const DEFAULT_LAYER = 0;
export const BATCHED_OBJECTS_LAYER = 2;
export const HELPER_LAYER = 31;
